import PageTitle from "../../components/title/pageTitle";
import Navigation from "../../components/navigation/navigation";
import Footer from "../../components/footer/footer";
import BackHomeIcon from "../../components/icons/BackHome/backhome";
import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n";
import "./about.css";

function InlineText({ text }) {
    const parts = String(text)
        .split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g)
        .filter(Boolean);

    return (
        <>
            {parts.map((part, index) => {
                if (part.startsWith("**") && part.endsWith("**") && part.length > 4) {
                    return <strong key={index}>{part.slice(2, -2)}</strong>;
                }
                if (part.startsWith("*") && part.endsWith("*") && part.length > 2) {
                    return <em key={index}>{part.slice(1, -1)}</em>;
                }
                return part;
            })}
        </>
    );
}

function About() {
    const { t } = useTranslation();
    const focusAreas = t("pages.about.focusAreas") || [];
    const photographyHighlights = t("pages.about.photography.highlights") || [];
    const partnershipItems = t("pages.about.partnerships.items") || [];

    return (
        <>
            <PageTitle>
                <Navigation />
            </PageTitle>

            <BackHomeIcon />

            <main className="about-page">
                <section className="about-intro">
                    <h1>{t("pages.about.title")}</h1>
                    <p className="about-intro__lead">
                        <InlineText text={t("pages.about.intro")} />
                    </p>
                    <div className="about-focus">
                        {focusAreas.map((item) => (
                            <div className="about-focus__item" key={item.label}>
                                <p className="about-focus__label">
                                    <InlineText text={item.label} />
                                </p>
                                <p className="about-focus__description">
                                    <InlineText text={item.text} />
                                </p>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="about-section about-section--muted">
                    <div className="about-section__inner">
                        <div className="about-section__heading">
                            <h2>{t("pages.about.photography.title")}</h2>
                        </div>
                        <div className="about-section__content">
                            <p>
                                <InlineText text={t("pages.about.photography.lead")} />
                            </p>
                            <ul className="about-list">
                                {photographyHighlights.map((item) => (
                                    <li key={item}>
                                        <InlineText text={item} />
                                    </li>
                                ))}
                            </ul>
                            <p>
                                <InlineText text={t("pages.about.photography.summary")} />
                            </p>
                            <Link className="about-more-link" to="/photography">
                                {t("pages.about.photography.moreLink")}
                            </Link>
                        </div>
                    </div>
                </section>

                <section className="about-section">
                    <div className="about-section__inner">
                        <div className="about-section__heading">
                            <h2>{t("pages.about.partnerships.title")}</h2>
                        </div>
                        <div className="about-section__content">
                            <p>
                                <InlineText text={t("pages.about.partnerships.lead")} />
                            </p>
                            <p>
                                <InlineText text={t("pages.about.partnerships.body")} />
                            </p>
                            <h3 className="about-subheading">{t("pages.about.partnerships.listTitle")}</h3>
                            <ul className="about-list">
                                {partnershipItems.map((item) => (
                                    <li key={item}>
                                        <InlineText text={item} />
                                    </li>
                                ))}
                            </ul>
                            <Link className="about-more-link" to="/creator-partnerships">
                                {t("pages.about.partnerships.moreLink")}
                            </Link>
                        </div>
                    </div>
                </section>

                <section className="about-philosophy">
                    <div className="about-philosophy__inner">
                        <h2>{t("pages.about.philosophy.title")}</h2>
                        <p className="about-philosophy__body">
                            <InlineText text={t("pages.about.philosophy.body")} />
                        </p>
                        <p className="about-philosophy__closing">
                            <InlineText text={t("pages.about.philosophy.closing")} />
                        </p>
                    </div>
                </section>

                <section className="about-signature">
                    {/*<p className="about-signature__name">*/}
                    {/*    <InlineText text={t("pages.about.signature.name")} />*/}
                    {/*</p>*/}
                    {/*<p className="about-signature__role-en">*/}
                    {/*    <InlineText text={t("pages.about.signature.roleEn")} />*/}
                    {/*</p>*/}
                    {/*<p className="about-signature__role-zh">*/}
                    {/*    {t("pages.about.signature.roleZh")}*/}
                    {/*</p>*/}
                    <p className="about-signature__brand">
                        <InlineText text={t("pages.about.signature.brand")} />
                    </p>
                </section>
            </main>

            <Footer />
        </>
    );
}

export default About;
